import { ConfigFn } from '@config/types'

const config = (({ publication, nemosyneUrl }) =>
  ({
    baseUrl: nemosyneUrl,
    getAllEntitySubscriptionsUrl: `/entity-subscription/{ENTITY_TYPE}?publication=${publication}`,
    setEntitySubscriptionUrl: `/entity-subscription?publication=${publication}`,
    deleteEntitySubscriptionUrl: `/entity-subscription/{ENTITY_TYPE}/{ENTITY_ID}?publication=${publication}`,
  }) as const) satisfies ConfigFn

export default config
